import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import theme from "./Common/style/core/config/theme";
import persistStore from "redux-persist/es/persistStore";
import store from "./store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { StoreProvider as EProvider } from "easy-peasy";
import { createStore } from "easy-peasy";
import models from "./store";
import { TeamContextProvider } from "./Common/Contex/TeamContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const Estore = createStore(models);
const persistor = persistStore(store);
root.render(
  <Provider store={store}>
    <EProvider store={Estore}>
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <TeamContextProvider>
          <App />
        </TeamContextProvider>
      </PersistGate>
    </EProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
